/**
 * Configuration utility for accessing environment variables
 */

// API URL from environment or fallback to default
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

// Debug mode flag
const DEBUG_MODE = process.env.REACT_APP_DEBUG === 'true';

// Application version
const APP_VERSION = process.env.REACT_APP_VERSION || '0.1.0';

// Environment name
const IS_PRODUCTION = process.env.NODE_ENV === 'production';
const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';
const IS_TEST = process.env.NODE_ENV === 'test';

// Logger that only logs in debug mode
const logger = {
  log: (message: string, ...args: any[]) => {
    if (DEBUG_MODE) {
      console.log(`[DEBUG] ${message}`, ...args);
    }
  },
  error: (message: string, ...args: any[]) => {
    if (DEBUG_MODE) {
      console.error(`[ERROR] ${message}`, ...args);
    }
  },
  warn: (message: string, ...args: any[]) => {
    if (DEBUG_MODE) {
      console.warn(`[WARN] ${message}`, ...args);
    }
  },
  info: (message: string, ...args: any[]) => {
    if (DEBUG_MODE) {
      console.info(`[INFO] ${message}`, ...args);
    }
  },
};

export { API_URL, DEBUG_MODE, APP_VERSION, IS_PRODUCTION, IS_DEVELOPMENT, IS_TEST, logger };
